/**
 * @lodex-pro/shared/bank-numbers — US bank number checks (OPEN-212 PR A, DEC-387 D7).
 *
 * Shared by the API (which enforces them on Paelode's remittance details) and web-admin (which
 * says what is wrong before the save), so the two cannot disagree.
 */

/** An ABA routing number: 9 digits whose 3-7-1 weighted sum is a multiple of 10. */
export function isAbaRoutingNumber(v: string): boolean {
  if (!/^[0-9]{9}$/.test(v)) return false;
  const d = [...v].map(Number);
  const sum = 3 * (d[0]! + d[3]! + d[6]!) + 7 * (d[1]! + d[4]! + d[7]!) + (d[2]! + d[5]! + d[8]!);
  return sum % 10 === 0;
}

/** A US bank account number as banks print it: 4 to 17 digits. */
export function isBankAccountNumber(v: string): boolean {
  return /^[0-9]{4,17}$/.test(v);
}
